import React from 'react';

export const NotFoundConfig = {
    settings: {
        layout: {
            config: {
                header: { display: true },
                footer: { display: true },
                navbar: { display: true },
            },
        },
    },
    isPrivate: false,
    eventName: 'not_found',
    routes: [
        {
            path: '/not-found',
            component: React.lazy(() => import('./NotFound')),
        },
    ],
};
